import { render, staticRenderFns } from "./EditType.vue?vue&type=template&id=d0415ea2&scoped=true"
import script from "./EditType.vue?vue&type=script&lang=js"
export * from "./EditType.vue?vue&type=script&lang=js"
import style0 from "./EditType.vue?vue&type=style&index=0&id=d0415ea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0415ea2",
  null
  
)

export default component.exports